import CreatePrivateRoomSidePane from "./CreatePrivateRoomSidePane";
export default CreatePrivateRoomSidePane;
